import { render, staticRenderFns } from "./CustomQuestionAnswerMergeTags.vue?vue&type=template&id=7d428874"
import script from "./CustomQuestionAnswerMergeTags.vue?vue&type=script&lang=js"
export * from "./CustomQuestionAnswerMergeTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports